module.exports = __webpack_public_path__ + "img/enhancing-safety.b6221287.svg";